import { Platform } from './Platform';
import { PlatformService } from './PlatformService';
import { SupportedTags } from './Tags';
import { PlatformTag } from './types';

export const getPlatformTag = (): PlatformTag => {
    return PlatformService.instance.getTag();
};

export const getPlatformFromNextContext = (ctx: { req?: { headers?: any }; query?: Record<string, any> }) => {
    const headers = ctx?.req?.headers || {};
    let platform = '';

    if (process.env.NEXT_APP_PLATFORM) {
        platform = process.env.NEXT_APP_PLATFORM;
    } else if (headers) {
        const platformHeader = headers['x-project'] || headers['x-platform'];
        platform = Array.isArray(platformHeader) ? platformHeader.join(';') : platformHeader;
    }

    if (!platform) {
        platform = ctx?.query?._platform;
    }

    return Platform.from(platform || SupportedTags.APPAREL_ORDER);
};
